import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { ThankyouComponent } from '../shared/thankyou/thankyou.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { PrivacyAndPolicyComponent } from './privacy-and-policy/privacy-and-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { ChildSafetyPolicyComponent } from './child-safety-policy/child-safety-policy.component';
import { IdentityVerificationHandoffComponent } from './identity-verification-handoff/identity-verification-handoff.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { TroubleSignupComponent } from './trouble-signup/trouble-signup.component';

const routes: Routes = [
  {
    path: 'login',
    component: SigninComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'trouble-signing-up',
    component: TroubleSignupComponent,
  },
  {
    path: 'identity-verification/complete',
    component: IdentityVerificationHandoffComponent,
  },
  {
    path: 'thankyou',
    component: ThankyouComponent,
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,
  },
  {
    path: 'resetPassword/:id',
    component: ResetPasswordComponent,
  },
  {
    path: 'edit-user',
    component: EditUserComponent,
  },
  {
    path: 'privacy-and-policy',
    component: PrivacyAndPolicyComponent,
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'deleteAccount',
    component: DeleteAccountComponent,
  },
  {
    path: 'unsubscribe/:userId',
    component: UnsubscribeComponent,
  },
  {
    path: 'child-safety-policy',
    component: ChildSafetyPolicyComponent,
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
  },

  // {
  //   path: '**',
  //   redirectTo: '/homepage',
  //   pathMatch: 'full',
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
